import request from '../../../../../services/axios';
import {IBankAccountInfo} from '../getBankAccountInfo/getBankAccountInfo';

export type IPostBankAccountInfoPayload = Omit<IBankAccountInfo, 'guid'>;

export const postBankAccountInfo = async (
  payload: IPostBankAccountInfoPayload,
) => {
  const {data} = await request.post(
    `/api/v2/payment/cashback/bank-info`,
    payload,
  );

  return data;
};
